import { Component, OnInit, Input } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";

@Component({
  selector: "products-in-group-dialog",
  templateUrl: "./products-in-group-dialog.component.html",
  styleUrls: ["./products-in-group-dialog.component.scss"]
})
export class ProductsInGroupDialogComponent implements OnInit {
  @Input() title: any;
  @Input() description: any;

  constructor(
    public dialogRef: MatDialogRef<ProductsInGroupDialogComponent>,
    private router: Router
  ) {}

  ngOnInit() {}

  confirm() {
    this.dialogRef.close();
    this.router.navigate(["/dashboard-manager"]);
  }

  close() {
    this.dialogRef.close();
  }
}
